import type { ProductSalesReportComponentProps } from './ProductSalesReportComponent';

export const ProductSalesReportComponent = {
    MountAsync: async (target: HTMLElement, props: ProductSalesReportComponentProps) => {
        const { mountReactComponentAsync } = await import('@/utils/mountReactComponentAsync');
        const { ProductSalesReportComponent } = await import('./ProductSalesReportComponent');
        return await mountReactComponentAsync(target, ProductSalesReportComponent, props);
    }
};